import React, { useEffect, useState } from "react";
import styled from "styled-components";
import storage from "local-storage-fallback";

import {
  brands,
  determineBrandBasedOnUrl
} from "components/care_solved/careSolvedHelper";
import CareCoach from "components/care_solved/CareCoach";
import CareMatch from "components/care_solved/CareMatch";
import CareSolvedQuery from "components/care_solved/CareSolvedQuery";
import LoadingSpinner from "components/utils/LoadingSpinner";
import LoginPortal from "components/care_solved/LoginPortal";

const StyledCareSolved = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const StyledCareMessage = styled.p`
  margin-bottom: 1rem;
`;

const StyledCareOptions = styled.div`
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
`;

export default function CareSolvedPage() {
  const [loginDetails, setLogInDetails] = useState(undefined);
  const [brand, setBrand] = useState(undefined);

  function checkLoggedInState() {
    const sessionStorage = JSON.parse(storage.getItem("cs-portal"));
    setLogInDetails(
      sessionStorage && {
        email: sessionStorage.email,
        membershipNumber: sessionStorage.membershipNumber
      }
    );
  }

  function determineBrand() {
    const urlBrand = determineBrandBasedOnUrl();
    if (urlBrand) {
      setBrand(brands[urlBrand]);
    }
  }

  useEffect(() => {
    checkLoggedInState();
    determineBrand();
  }, []);

  if (loginDetails === undefined) {
    return <LoadingSpinner />;
  }

  const email = loginDetails && loginDetails.email;
  const membershipNumber = loginDetails && loginDetails.membershipNumber;
  const loggedIn = !!email && !!membershipNumber;

  const careService = <strong>CareSolved by SuperCarers service</strong>;
  const loggedInMessage = (
    <>
      As a {brand} member, you have access to the {careService} which includes
      three elements:
    </>
  );
  const loggedOutMessage = `As a ${brand} member, you have access to this dedicated and confidential
  service for you and your family.`;

  return (
    <StyledCareSolved>
      {loggedIn ? (
        <>
          <StyledCareMessage>{loggedInMessage}</StyledCareMessage>
          <StyledCareOptions>
            <CareCoach />
            <CareMatch />
            <CareSolvedQuery
              email={email}
              membershipNumber={membershipNumber}
            />
          </StyledCareOptions>
        </>
      ) : (
        <>
          <StyledCareMessage>{loggedOutMessage}</StyledCareMessage>
          <LoginPortal setLogInDetails={setLogInDetails} />
        </>
      )}
    </StyledCareSolved>
  );
}
